import React, { useEffect, useMemo } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import Loader from '@src/components/atoms/Loader';
import { useAuthenticate } from '@src/hooks';
import { getCookie } from '@src/utils';

const AuthCallback = (props: RouteComponentProps) => {
  const {
    location: { hash },
  } = props;

  const { authenticate, loading, error } = useAuthenticate();

  const redirectTo = useMemo(() => {
    const path = getCookie('path') ?? '/';
    const returnToPath = path.includes('/auth/callback') ? '/' : path;
    return returnToPath;
  }, []);

  useEffect(() => {
    (async function auth() {
      if (!hash) {
        return;
      }
      await authenticate({ hash });
    })();
  }, [authenticate, hash]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Redirect
        to={{
          pathname: redirectTo,
          state: { signinError: error },
        }}
      />
    );
  }

  return null;
};

export default AuthCallback;
